import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { AsideMenuModule } from '@epicuro-next/ataraxia/aside-menu';
import { CheckboxGroupModule } from '@epicuro-next/ataraxia/checkbox-group';
import { DateModule } from '@epicuro-next/ataraxia/date';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { MultiRangeSliderModule } from '@epicuro-next/ataraxia/multi-range-slider';
import { RadioGroupModule } from '@epicuro-next/ataraxia/radio-group';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';

import { FilterSelectComponent } from './components/filter-select/filter-select.component';
import { FiltersListComponent } from './components/filters-list/filters-list.component';
import { FEATURE_NAME } from './configurations';

@NgModule({
  imports: [
    AccordionModule,
    CommonModule,
    ConfigurationModule.forFeature(FEATURE_NAME),
    IconsModule,
    MultiRangeSliderModule,
    TooltipDirective,
    AsideMenuModule,
    CheckboxGroupModule,
    RadioGroupModule,
    DateModule,
  ],
  declarations: [FiltersListComponent, FilterSelectComponent],
  exports: [FiltersListComponent],
})
export class FiltersListModule {}
